import { render, staticRenderFns } from "./ProjectsSingleHeader.vue?vue&type=template&id=44bc97ce&"
import script from "./ProjectsSingleHeader.vue?vue&type=script&lang=js&"
export * from "./ProjectsSingleHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports